import React from 'react';
import LoadingWheel from '../../components/shared/LoadingWheel';
import useTemplatePolicies from '../../data/useTemplatePolicies';
import TemplatePolicyEditor from '../../components/templatePolicies/TemplatePolicyEditor';
import { TemplatePolicyType } from "../../models/TemplatePolicy";

export default function TemplatePolicies() {
  const { templatePolicies, getTemplatePolicyByType } = useTemplatePolicies();

  if (templatePolicies.isLoading) {
    return <LoadingWheel />;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Template Policies
        </h1>

        <p className="text-gray-600">
          Manage your warranty, terms & conditions, and returns policies. Each policy type can be created or updated using the rich text editor below.
        </p>
      </div>

      {Boolean(templatePolicies.error) && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-6">
          Failed to load template policies
        </div>
      )}

      {(Object.values(TemplatePolicyType)
        .filter((v) => typeof v === "number") as TemplatePolicyType[])
        .map((type) => (
          <TemplatePolicyEditor
            key={type}
            type={type}
            policy={getTemplatePolicyByType(type)}
          />
        ))}
    </div>
  );
}
